import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './NewsEvents.css';

const NewsEvents = ({ title, subtitle }) => {
  const [activeTab, setActiveTab] = useState('all');

  const newsItems = [
    {
      id: 1,
      type: 'news',
      title: 'MINT School Students Excel in WAEC Examinations',
      excerpt: 'Our SSS 3 students achieved a 98% pass rate in the 2024 WAEC examinations, with 75% scoring distinctions in 5 or more subjects.',
      image: '/assets/images/news/waec-results.jpg',
      date: '2024-08-15',
      category: 'Academic Achievement'
    },
    {
      id: 2,
      type: 'event',
      title: 'Annual Sports Day 2024',
      excerpt: 'Join us for our exciting Annual Sports Day featuring athletics, football, volleyball, and cultural displays. All parents and guardians are invited!',
      image: '/assets/images/events/sports-day.jpg',
      date: '2024-11-20',
      category: 'School Event'
    },
    {
      id: 3,
      type: 'news',
      title: 'New Science Laboratory Commissioned',
      excerpt: 'The school unveiled a state-of-the-art science laboratory equipped with modern equipment to enhance practical learning in Physics, Chemistry, and Biology.',
      image: '/assets/images/news/science-lab.jpg',
      date: '2024-09-10',
      category: 'Infrastructure'
    },
    {
      id: 4,
      type: 'event',
      title: 'Parent-Teacher Conference',
      excerpt: 'We invite all parents for our termly conference to discuss student progress and development. Individual consultation slots available.',
      image: '/assets/images/events/ptc.jpg',
      date: '2024-12-05',
      category: 'Academic'
    },
    {
      id: 5,
      type: 'news',
      title: 'MINT School Wins Regional Debate Competition',
      excerpt: 'Our debate team emerged champions at the Benue State Schools Debate Championship, defeating 15 other schools in the finals.',
      image: '/assets/images/news/debate.jpg',
      date: '2024-08-28',
      category: 'Extracurricular'
    },
    {
      id: 6,
      type: 'event',
      title: 'Christmas Carol Service & Concert',
      excerpt: 'Celebrate the season with our annual Christmas carol service featuring performances by our school choir and drama club.',
      image: '/assets/images/events/christmas.jpg',
      date: '2024-12-15',
      category: 'Cultural'
    }
  ];

  const filteredItems = activeTab === 'all'
    ? newsItems
    : newsItems.filter(item => item.type === activeTab);

  const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(dateString).toLocaleDateString('en-US', options);
  };

  return (
    <section className="news-events-section">
      <div className="container">
        {title && <h2 className="section-title">{title}</h2>}
        {subtitle && <p className="section-subtitle">{subtitle}</p>}

        {/* Tabs */}
        <div className="news-events-tabs">
          <button
            className={`tab ${activeTab === 'all' ? 'active' : ''}`}
            onClick={() => setActiveTab('all')}
          >
            All Updates
          </button>
          <button
            className={`tab ${activeTab === 'news' ? 'active' : ''}`}
            onClick={() => setActiveTab('news')}
          >
            News
          </button>
          <button
            className={`tab ${activeTab === 'event' ? 'active' : ''}`}
            onClick={() => setActiveTab('event')}
          >
            Upcoming Events
          </button>
        </div>

        {/* Grid */}
        <div className="news-events-grid">
          {filteredItems.map((item, index) => (
            <article
              key={item.id}
              className="news-event-card"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="card-image">
                <img src={item.image} alt={item.title} loading="lazy" />
                <div className="card-badge">
                  {item.type === 'event' ? (
                    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect x="3" y="4" width="18" height="18" rx="2" stroke="currentColor" strokeWidth="2"/>
                      <path d="M16 2V6M8 2V6M3 10H21" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                    </svg>
                  ) : (
                    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M19 20H5C3.89543 20 3 19.1046 3 18V6C3 4.89543 3.89543 4 5 4H19C20.1046 4 21 4.89543 21 6V18C21 19.1046 20.1046 20 19 20Z" stroke="currentColor" strokeWidth="2"/>
                      <path d="M3 10H21M7 15H12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                    </svg>
                  )}
                  <span>{item.type === 'event' ? 'Event' : 'News'}</span>
                </div>
                <div className="card-category">{item.category}</div>
              </div>

              <div className="card-content">
                <div className="card-date">
                  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/>
                    <path d="M12 6V12L16 14" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                  </svg>
                  {formatDate(item.date)}
                </div>

                <h3>{item.title}</h3>
                <p>{item.excerpt}</p>

                <Link to={`/${item.type}/${item.id}`} className="read-more">
                  Read More
                  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </Link>
              </div>
            </article>
          ))}
        </div>

        {/* View All Button */}
        <div className="news-events-footer">
          <Link to="/news-events" className="btn btn-primary">
            View All Updates
          </Link>
        </div>
      </div>
    </section>
  );
};

export default NewsEvents;
